<template>
    <v-sheet color="transparent">        
        <div class="tit-wrap">
            <v-row>
                <v-col cols="auto" data-aos="fade-right" data-aos-delay="100">
                    <h3 class="tit tit--bar">진행중인 프로그램</h3>
                </v-col>
                <v-spacer />
                <v-col cols="auto" class="text-right" data-aos="fade-left" data-aos-delay="100">
                    <v-row class="ma-n4">
                        <v-col cols="auto" class="pa-4">
                            <v-btn icon tile outlined color="grey" class="slide-prev">
                                <icon-arrow-rounded direction="left" class="icon--size-small" />
                            </v-btn>
                        </v-col>
                        <v-col cols="auto" class="pa-4">
                            <v-btn icon tile outlined color="grey" class="slide-next">
                                <icon-arrow-rounded direction="right" class="icon--size-small" />
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div class="program-slide">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="application in applications" :key="application?._id" class="swiper-slide">
                        <image-board tile flat @click="move(application)" style="background-color: transparent;">
                            <template #image>
                                <v-responsive width="100%" :aspect-ratio="282 / 370" class="image-card grey lighten-5" :style="'background-image: url(' + application?.thumb.src + ');'">
                                    <v-overlay absolute opacity="0" class="pt-10px pl-10px justify-start align-start">
                                        <v-chip large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">{{ application?.status }}</span></v-chip>
                                    </v-overlay>
                                </v-responsive>
                            </template>

                            <template #subject>
                                {{ application?.subject }}
                            </template>

                            <template>
                                <v-row class="row--xs">
                                    <template v-for="(item, index) in application?.items">
                                        <v-col cols="12" v-if="item.title == '모집 기간'" :key="index">
                                            <div v-html="item.txt.replace(/\n/g, '<br/>')" class="font-size-16 grey--text text--lighten-1"></div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </template>
                        </image-board>
                    </div>
                </div>
            </div>
        </div>
    </v-sheet>
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";

const statuses = [
    { name: "전체", value: null },
    { name: "모집중", value: "모집중" },
    { name: "모집 종료", value: "모집 종료" },
];

import ImageBoard from "@/components/dumb/image-board.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

export default {
    props: {},
    components: {
        ImageBoard,
        IconArrowRounded,
    },
    data: () => {
        return {
            statuses,
            applications: [],
            filter: {
                status: "모집중"
            },
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {

            let [{ applications: kea }, { applications: education }, { applications: circulation }] = await Promise.all([
                api.v1.kea.applications.gets({params: this.filter}),
                api.v1.education.applications.gets({params: this.filter}),
                api.v1.circulation.applications.gets({params: this.filter}),
            ])
            
            for(let i = 0; i < kea.length - 1; i++) {
                kea[i].code = "kea";
            }

            for(let i = 0; i < education.length - 1; i++) {
                education[i].code = "education";
            }

            for(let i = 0; i < circulation.length - 1; i++) {
                circulation[i].code = "circulation";
            }

            let sortedApplications = [...kea, ...education, ...circulation].sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt)
            })
            sortedApplications.splice(6, sortedApplications.length - 1)
            this.applications = sortedApplications
            this.$nextTick(() => {
                this.Program = new Swiper('.program-slide .swiper-container', {
                    spaceBetween: 10,
                    slidesPerView: 2,
                    speed: 500,
                    loop: false,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        prevEl: '.slide-prev',
                        nextEl: '.slide-next',
                    },
                    breakpoints: {
                        768:{
                            spaceBetween: 24,
                        },
                    },
                });
            });
        },
        move(application) {
            if (application.code === "kea") {
                this.$router.push(`/pitching-festa/support/${application?._id}`)
            } else if(application.code === "education") {
                this.$router.push(`/education/receipt/${application?._id}` )
            } else {
                this.$router.push(`/circulation/support/${application?._id}` )
            }
        },
        routerMove() {
            
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
